import { createFileRoute } from '@tanstack/react-router'

import { BlytzCollectAnalyticsScreen } from './-components/analytics-screen.tsx'
import { validateAnalyticsSearch } from './-lib/analytics-search.ts'

export const Route = createFileRoute('/blytzcollect/analytics')({
  // The page's choices live in the URL, so a reload or a link keeps them and
  // Alert me captures them. Typed loosely on purpose: a typed search on one
  // route narrows the search type of every `navigate` call in the app. The
  // screen reads it back through the same parser.
  validateSearch: (search: Record<string, unknown>): Record<string, unknown> =>
    validateAnalyticsSearch(search),
  component: BlytzCollectAnalyticsScreen
})
